import useSWR from "swr";
import { api, fetcher } from "services/api.service";
import useSWRMutation from "swr/mutation";
import { useState } from "react";
import { LabelComponentsInfo, LabelPrintRequest } from "types/labelPrintRequest";

async function createLabelPrintRequest(_key: string, { arg: { box_type } }: { arg: { box_type: string } }) {
  const response = await api.post("/label_print_requests", { box_type });

  return response.data;
}

export default function useLabelPrintRequest() {
  const [labelPrintRequestId, setLabelPrintRequestId] = useState<string | null>(null);

  const { trigger: printLabels, isMutating: isPrintingLabels } = useSWRMutation(
    "/label_print_requests",
    createLabelPrintRequest,
  );

  const { data: labelPrintRequestData, isLoading: isLoadingLabelPrintRequestData } = useSWR<LabelPrintRequest>(
    labelPrintRequestId ? `/label_print_requests/${labelPrintRequestId}` : null,
    fetcher,
    {
      refreshInterval: 1000,
    },
  );

  const { data: labelComponentsData, isLoading: isLoadingLabelComponents } = useSWR<LabelComponentsInfo>(
    "/label_print_requests",
    fetcher,
  );

  return {
    printLabels,
    isPrintingLabels,
    labelPrintRequestData,
    isLoadingLabelPrintRequestData,
    setLabelPrintRequestId,
    labelComponentsData,
    isLoadingLabelComponents,
  };
}
